module.exports = __webpack_public_path__ + "img/realname_2.b6caacdd.png";